<template>
  <div class="collection-page">
    <p class="breadcrumb">
      <button @click="goBack">< Back</button>
    </p>
    <div id="cHeader" class="header-section">
        <picture>
					<source media="(max-width: 767px)" :srcset="mobileImage">
					<img alt="header" class="lazyload main-image" :src="headerImage"/>
				</picture>  
        <div class="floating-container">
            <p class="goc">GIFT OF CHOICE</p>
            <p class="title">The {{ title }} {{ isInternational ? 'International' : '' }} Collection</p>
            <p class="subtitle">Your recipients will pick from great gifts & you’ll stay in budget: <br class="mobile"/> ${{ collectionPrice }}, including {{ isInternational ? 'International ' : 'US' }} shipping.</p>
            <div class="buttons-container">
                <button @click="changePage()" class="happybox-button green border">{{sendCopy}}</button>
            </div>
        </div>
    </div>
    <div id="stickyHead" class="sticky-head">
      <div class="cta-containers">
        <button @click="changePage()" class="happybox-button green border">{{sendCopy}}</button>
      </div>
    </div>
    <div class="top-section">
      <div class="filter-space"></div>
      <div class="main-container">
        <div class="title-container">
          <div class="budget-container">
            <p class="container-title">Pick your Budget</p>
            <select id="budgetselector" v-model="collectionId" @change="budgetChanged($event)">
              <option v-for="collection in categoryCollections" :key="collection.id" :value="collection.id">{{collection | moneyFloatFormat}}</option>
            </select>
          </div>
          <p class="container-title">Here's what your recipient can choose from</p>
        </div>
        <div class="section-container" v-for="(tab,i) in orderedProducts" :key="i">
          <p class="section-title"><strong v-if="!isInternational">${{ tab.value }} Value gifts:</strong> Your recipient can pick {{ tab.qty }} of these gifts<span v-if="selectedCollection.value % tab.value"> and {{ getRemainder(selectedCollection.value % tab.value) }}</span><span v-else>.</span>
          </p>
          <div 
            :ref="'productsContainer' + i"
            class="products-container"
            :class="{ collapsed: isCollapsed[i] }"
            @transitionend="handleTransitionEnd(i)"
          >
            <div class="product-item" v-for="product in tab.products" :key="product.id">
              <p v-if="ethosTag(product)" class="main-badge" :class="badgeExtraClass(product)">{{ ethosTag(product) }}</p>
              <img @click="selectProduct(product)" class="i" src="https://cdn.shopify.com/s/files/1/1363/8433/files/information.svg?v=1731080982"/>
              <div @click="selectProduct(product)" class="image-container">
                <img class="lazyload" :src="product | getProductImage"/>
                <button class="happybox-button white border">View</button>
              </div>
              <p class="product-title">{{ product.title }}</p>
            </div>
          </div>
          <button class="show" v-if="tab.products.length > 8" @click="toggleCollapse(i)">
            {{ isInternational ? (isCollapsed[i] ? `Show More Gifts` : `Show Less Gifts`)  : (isCollapsed[i] ? `Show More $${tab.value} Gifts` : `Show Less $${tab.value} Gifts`) }}
          </button>
        </div>
      </div>
    </div>
    <div class="bottom-section">
      <Inquire/>
    </div>
    <ProductModal @closemodal="selectProduct(null)" @changepage="changePage()" :product="selectedProduct" :sendCopy="sendCopy"  v-if="selectedProduct"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Inquire from './Snippets/Inquire.vue';
import Filters from './BudgetFilters/Filters.vue';
import ProductModal from './Snippets/ProductModal.vue'
export default {
  components:{
    Inquire,
    Filters,
    ProductModal
  },
  data(){
    return{
      isCollapsed: [],
      collapsedHeight: [],
      collectionId: null,
      selectedProduct: null,
    }
  },
  watch: {
    orderedProducts: {
      immediate: true,
      handler(tabs) {
        tabs.forEach((tab, index) => {
          this.$set(this.isCollapsed, index, true);
          this.$nextTick(() => {
            this.checkRows(index);
          });
        });
      },
    },
  },
  computed:{
    ...mapGetters([
      'selectedCollection',
      'giftCollections'
    ]),
    isLoading(){
      if(!this.selectedCollection.collectionProducts || this.selectedCollection.collectionProducts == 0){
        return true
      }

      return false
    },
    categoryCollections(){
      let category = this.selectedCollection.category;
      if(category){
        return this.giftCollections.filter(x => x.category == category);
      }

      return [];
    },
    headerImage(){
      if(this.selectedCollection.images.length > 1){
        return this.selectedCollection.images[this.selectedCollection.images.length - 1].src
      }

      return null
    },
    mobileImage(){
      if(this.selectedCollection.images.length > 1){
        return this.selectedCollection.images[this.selectedCollection.images.length - 2].src
      }

      return null
    },
    collectionPrice(){
      if(this.selectedCollection && this.selectedCollection.variants && this.selectedCollection.variants.length > 0)
        return parseFloat(this.selectedCollection.variants[0].price);

      return 0
    },
    tabs(){
      if(this.selectedCollection.collectionProducts && this.selectedCollection.collectionProducts.length > 0 && this.selectedCollection.value){
        let values = this.selectedCollection.collectionProducts.map((x) => {
        let tags = x.tags;
        if(!Array.isArray(x.tags)){
            tags = x.tags.split(", ");
        }
        let value = tags.find(y => y.toLowerCase().includes("goc_capacity_"))
        if(value){
            value = value.split("_")[2];

            return parseInt(value);
        }

        return 0;
        })
        
        values = [...new Set(values.filter(x => x > 0))].map(x => {return {maxQty: Math.floor(this.selectedCollection.value / x),value:x}});
        values.sort((a,b) => b.value - a.value);
        return values;
      }

      return [];
    },
    orderedProducts(){
      if(this.tabs && this.tabs.length > 0){
        return this.tabs.map((x) =>{
          let tag = `GOC_Capacity_${x.value}`;
          let products = this.selectedCollection.collectionProducts.filter(x => Array.isArray(x.tags) && x.tags.some(y => y == tag));
          return {qty: x.maxQty,products:products, value: x.value};
        })
      }

      return [];
    },
    isMobile() {
      return window.innerWidth < 768;
    },
    title(){
      if(this.selectedCollection.tags.some(x => x == "Featured")){
        return this.selectedCollection.category;
      }
      else {
        return `$${this.collectionPrice}`;
      }
    },
    sendCopy(){
      if(this.isMobile){
        return "Send This Collection"
      }
      if(this.selectedCollection.tags.some(x => x == "Featured")){
        return `Send: The $${this.collectionPrice} ${this.selectedCollection.category} Collection`;
      }
      else {
        return `Send: The $${this.collectionPrice} Collection`;
      }
    },
    isInternational(){
      return this.selectedCollection.tags.some(x => x == "International");
    },
  },
  methods:{
    goBack(){
      this.$store.commit('setSelectedCollection', null );
    },
    getRemainder(remainder){
      let tab = this.tabs.find(x => x.value <= remainder);
      if(tab){
        let gifts = remainder/tab.value;
        if(this.isInternational){
          return `${gifts} ${gifts > 1 ? 'gifts' : 'gift'} below.`
        }
        return `${gifts} $${tab.value} ${gifts > 1 ? 'gifts' : 'gift'}.`
      }

      return null
    },
    budgetChanged(event){
      let collection = this.giftCollections.find(x => x.id == this.collectionId);
      if(collection){
        this.collapseAll();
        window.scrollTo(0,0);
        this.$store.commit('setSelectedCollection', collection );
      }
    },
    selectProduct(product){
      this.selectedProduct = product;
    },
    async checkRows(index) {
      await new Promise(resolve => setTimeout(resolve, 300));
      this.$nextTick(() => {
        if(this.$refs['productsContainer' + index]){
          const container = this.$refs['productsContainer' + index][0];
          const items = container.querySelectorAll('.product-item');
          const itemHeight = items[0] ? items[0].clientHeight : 0;
          if (items.length > 8) {
            const visibleHeight = 2 * itemHeight + 25; // Assuming 2 rows, adjust 20px for margins/paddings
            container.style.setProperty('--visible-height', `${visibleHeight}px`);
          } else {
            container.style.removeProperty('--visible-height');
          }
        }
      });
    },
    collapseAll(){
      for(const [i, value] of this.isCollapsed.entries()){
        if(!value){
          this.toggleCollapse(i);
        }
      }
    },
    toggleCollapse(index) {
      const container = this.$refs['productsContainer' + index][0];
      if (this.isCollapsed[index]) {
        // Expanding
        container.style.maxHeight = `${container.scrollHeight}px`;
        this.$nextTick(() => {
          this.$set(this.isCollapsed, index, false);
        });
      } else {
        // Collapsing
        container.style.maxHeight = `${this.collapsedHeight[index]}px`;
        this.$nextTick(() => {
            this.$set(this.isCollapsed, index, true);
            container.style.maxHeight = '';
            container.scrollIntoView({ behavior: 'smooth', block: 'end' });
        });
      }
    },
    handleTransitionEnd(index) {
      if(this.$refs['productsContainer' + index]){
        const container = this.$refs['productsContainer' + index][0];
        if (!this.isCollapsed[index]) {
          container.style.maxHeight = 'none';
        }
      }
    },
    changePage(){
      this.$emit('changepage',true);
    },
    ethosTag(product){
      if(product){
        var ethos = product.tags.filter(y => y.includes("Filter_Ethos"));
        if(ethos.length > 0){
          ethos = ethos.map((x) => {
          var currentEthos = x.replace("Filter_","").split("_")
          return currentEthos[1]
          })

          return ethos[0];
        }
      }

      return null
    },
    badgeExtraClass(product){
      switch(this.ethosTag(product)){
        case "Women Owned":
          return "pink";
        case "Small Biz":
          return "green"
        case "BIPOC Owned":
          return "yellow"
        case "Sustainable":
          return "dgreen"
        default:
          return '';
      }
    }
  },
  mounted() {
    this.collectionId = this.selectedCollection.id;
    this.orderedProducts.forEach((tab, index) => {
      this.$set(this.isCollapsed, index, true);
    });
    const header = document.getElementById('cHeader');
    const stickyHead = document.getElementById('stickyHead');

    const hOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.7
    };


    const hObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyHead.style.display = 'none';
        } else {
          stickyHead.style.display = 'flex';
        }
      });
    }, hOptions);

    hObserver.observe(header);
  }
}
</script>

<style>
  .flicking-goc-collection {
    min-width: 100%;
  }
  .flicking-goc-collection .flicking-camera{
    gap: 2%;
    padding: 1% 0;
  }
</style>
<style scoped>

    .collection-page{
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    }

    .header-section picture{
      display: flex;
    }

    .goc{
      width: 100%;
      margin: unset;
      font-weight: 700;
      font-size: 1.3vw;
    }

    .header-section{
      width: 100%;
      display: flex;
      position: relative;
      background-color: #fdf4f0;
      min-height: 270px;
      align-items: flex-end;
    }

    .header-section .main-image{
        width: 100%;
        padding-top: 6%;
    }

    .header-section .floating-container{
      width: 50%;
      position: absolute;
      top: 0%;
      left: 5%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-left: 2%;
    }

    .floating-container .title{
      font-size: 5vw;
      line-height: 0.8;
      font-family: Founders Grotesk, sans-serif;
      font-weight: 600;
      margin: unset;
      margin-bottom: 0.5rem;
      width: 100%;
    }

    .floating-container .buttons-container{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 5%;
    }

    .floating-container .back,.show{
        color: #A01ADB;
        text-decoration: underline;
        font-weight: bold;
        font-size: 1vw;
    }

    .show{
      width: 100%;
      text-align: right;
      font-size: 1.5vw;
      padding: 2% 5%;
      text-align: center;
    }

    .top-section{
        width: 100%;
        display: flex;
        flex-direction: row;
    }

    .top-section .main-container{
        width: 85%;
        padding: 5% 0 5% 2%;
    }

    .top-section .main-container .container-title{
        font-size: 3vw;
        line-height: 1;
        font-family: Founders Grotesk, sans-serif;
        font-weight: 600;
        margin: unset
    }

    .section-container{
        width: 100%;
        margin-bottom: 5%;
    }

    .bottom-section{
		background-image: linear-gradient(#f0fdf7, #e7eaff);
        padding: 5%;
	}

    .breadcrumb{
      color: #0f0c38;
      text-decoration: underline;
      position: absolute;
      top: 0%;
      left: 5%;
      z-index: 1;
	  }

    .breadcrumb > * {
      color: #a01adb;
      font-weight: bold;
      text-decoration: underline;
    }

    .products-container{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        gap: 2%;
        transition: max-height 0.5s ease;
        overflow: hidden;
        max-height: var(--visible-height);
    }

    .products-container.collapsed {
        max-height: var(--visible-height);
    }

    .product-item{
        width: 23%;
        border: 1px solid #e0e0e0;
        padding: 2%;
        display: flex;
        flex-direction: column;
        margin-bottom: 2%;
        background-color: white;
        border-radius: 8px;
        position: relative;
    }

    .product-item img{
      width: 100%;
      aspect-ratio: 1;
    }

    .product-item .i{
      position: absolute;
      width: 8%;
      z-index: 1;
      right: 5%;
      top: 5%;
      cursor: pointer;
    }

    .product-item .image-container{
      width: 100%;
      margin-bottom: 5%;
      position: relative;
      overflow: hidden;
      cursor: pointer;
    }

    .product-item .happybox-button{
      position: absolute;
      width: 90%;
      bottom: -30%;
      margin: unset;
      transition: all 0.5s ease-in-out;
      left: 5%;
    }

    .product-item .image-container:hover .happybox-button{
      bottom: 10%;
      z-index: 1;
    }

    .product-title {
        font-size: 1.15vw;
        font-weight: 700;
        margin: unset;
    }

    .section-title{
      padding-bottom: 1rem;
      border-bottom: 1px solid lightgray;
    }

    .sticky-head{
      display: flex;
      position: fixed;
      bottom: 0px;
      width: 100%;
      background-color: white;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
      padding: 1% 8%;
      align-items: center;
      gap: 10px;
      z-index: 2;
  }

  .sticky-head .cta-containers{
	  display: flex;
    align-items: center;
    width: 100%;
    gap: 15px;
    justify-content: center;
  }

  .sticky-head .cta-containers .happybox-button{
    padding: 1% 10%;
  }

  .title-container{
    display: flex;
    width: 100%;
    margin-bottom: 1rem;
    align-items: center;
    gap: 2%;
  }

  .budget-container{
    display: flex;
    align-items: center;
    gap: 20px;
  }

  #budgetselector{
    border: unset;
    background-color: white;
    box-shadow: 0 0 2px #0000004d;
    border-radius: 30px;
    background-size: 15px, 15px;
    background-image: url(https://cdn.shopify.com/s/files/1/1363/8433/files/Group_3438.png?v=1720194132), url(https://cdn.shopify.com/s/files/1/1363/8433/files/Group_1790.png?v=1720194132);
    background-position: right 10px center, left 10px center;
    padding: 1.5% 28px;
    width: unset;
    min-width: 120px;
    text-align: center;
    height: unset
  }

  .main-badge {
    background-color: #fff;
    position: absolute;
    top: 2%;
    left: 2%;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1% 3%;
    font-size: 1.1vw;
    font-weight: 700;
    color: #5981d9;
    z-index: 1;
  }

  .main-badge.pink{
    background-color: #fbdaff;
  }

  .main-badge.dgreen{
    background-color: #a9ffbd;
  }

  .main-badge.green {
    background-color: #d8efdf;
  }

  @media screen and (min-width: 768px){
    .floating-container .subtitle{
      padding-right: 10%;
      width: 100%;
    }
  }

  @media screen and (max-width: 767px) {

    .header-section{
      background-color: #FFF3E3;
    }
    .header-section .floating-container{
      width: 65%;
      padding: 5% 0% 5% 8%;
      left: 0;
    }

    .header-section .main-image{
      padding: unset;
    }

    .filter-space{
      width: 0%;
    }

    .top-section .main-container{
      width: 100%;
      padding: 5%;
    }

    .floating-container .buttons-container{
      justify-content: flex-start;
    }

    .top-section .main-container .container-title{
      font-size: 5vw;
      width: 100%;
    }

    .top-section .main-container .budget-container .container-title{
      width: auto;
    }

    .product-title{
      font-size: 3.5vw;
    }

    .show{
      font-size: 3.5vw;
    }

    .title-container{
      flex-direction: column;
    }

    .budget-container{
      width: 100%;
      margin-bottom: 1rem;
    }

    .sticky-head{
      padding: 5%;
    }

    .sticky-head .cta-containers .happybox-button{
      width: 80%;
    }

    .breadcrumb{
      top: 0.5%;
    }

    .section-title{
      font-size: 3.5vw;
    }

    .floating-container .title{
      font-size: 10vw;
    }

    .goc{
      font-size: 3.5vw;
      margin-bottom: 0.5rem;
    }

    .main-badge{
      font-size: 3vw;
    }

    .product-item{
      width: 49%;
    }

    .product-item .i{
      width: 10%;
    }
  }

</style>